<!-- MFITTで自動予約取消し後に予約変更・取消した場合 -->
<template>
  <ItemDialog ref="canNotChangeAfterCanceled" image-type="alert">
    <template #content-area>
      <p class="text-center">
        購入期限を過ぎたため、既にこの予約は自動で取り消されました。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotChangeAfterCanceled",
  setup() {
    const canNotChangeAfterCanceled = ref(null);

    const openDialog = () => {
      canNotChangeAfterCanceled.value.open();
    };

    const closeDialog = () => {
      canNotChangeAfterCanceled.value.close();
    };

    return {
      canNotChangeAfterCanceled,
      openDialog,
      closeDialog,
    };
  },
};
</script>
